/**
 * Yaqinda ko'rsatilgan xato matnlari — bir xil toast ketma-ket chiqmasin.
 *
 * Token yangilash navbati (`isRefreshing` + `failedQueue`) bu yerdan olib
 * tashlandi: yangilash endi `refresh.ts` dagi bitta va'da orqali ishlaydi
 * va uni do'kon ham, interceptor ham baham ko'radi.
 */
export const shownErrors = new Set<string>();
